import { logWrapper } from '../utils';
import toastr from 'toastr';

export default {
  companyModel: [
    'runtimeConstant',
    '$filter',
    'validationService',
    'contractModel',
    function (runtimeConstant, $filter, validationService, Contract) {
      var $scope = angular.element(document).scope();

      function Company(data, contractList) {
        if (!data) {
          data = {};
          data.Id = 0;
          data.IdStatus = 1;
          data.Name = '';
          data.Cnpj = '';
          data.Address = '';
          data.State = '';
          data.City = '';
          data.ZipCode = '';
          data.Phone = '';
          data.Email = '';
          data.ContactPerson = '';
          data.Segment = '';
          data.LogoFilename = '';
          data.HasAutoLogin = false;
          data.CanExportMedia = false;
          data.CanNFe = false;
          data.CanScheduledSend = false;
          data.CanDocusign = false;
          data.CanD4Sign = false;
          data.CanCertificata = false;
          data.DownloadOnlyWithName = false;
          data.CanUpperCase = false;
          data.RegistrationDate = new Date();
        }

        this.id = data.Id;
        this.idStatus = data.IdStatus;
        this.name = data.Name;
        this.cnpj = data.Cnpj ? data.Cnpj : '';
        this.address = data.Address;
        this.state = data.State;
        this.city = data.City;
        this.zipcode = data.ZipCode;
        this.phone = data.Phone;
        this.email = data.Email;
        this.contactPerson = data.ContactPerson;
        this.segment = data.Segment;
        this.logoFilename = data.LogoFilename;

        this.hasAutoLogin = data.HasAutoLogin;
        this.canExportMedia = false;
        this.canScheduledSend = data.CanScheduledSend;
        this.canSignFiles = data.CanSignFiles;
        this.canWorkflow = data.CanWorkflow;
        this.canNFe = data.CanNfe ? data.CanNfe : false;

        this.canD4Sign = data.CanD4Sign;
        this.canCertificata = data.CanCertificata;
        this.CanUpperCase = data.CanUpperCase ? data.CanUpperCase : false;
        this.DownloadOnlyWithName = data.DownloadOnlyWithName;
        this.certificateSerialNumber = data.CertificateSerialNumber
          ? data.CertificateSerialNumber
          : '';
        this.certificatePassword = data.CertificatePassword
          ? data.CertificatePassword
          : '';
        this.certificate = data.Certificate ? data.Certificate : '';
        this.legalName = data.LegalName ? data.LegalName : '';
        this.idContract = data.IdContract;
        this.CanDocusign = false;

        this.registrationDate = data.RegistrationDate;

        this.users = [];
        if (Array.isArray(data.Users)) {
          for (var i = 0; i < data.Users.length; i++) {
            this.users.push({
              id: data.Users[i].Id,
              name: data.Users[i].Name,
              email: data.Users[i].Email,
            });
          }
        }

        this.contracts = [];
        if (Array.isArray(contractList)) {
          for (var j = 0; j < contractList.length; j++) {
            this.contracts.push({
              id: contractList[j].Id,
              companyName: contractList[j].CompanyName,
            });
          }
        }
        this.contract = data.Contract
          ? new Contract(data.Contract)
          : this.contracts.filter(function (item) {
              return item.id === data.IdContract;
            })[0];

        this.allStatus = [
          { name: 'ACTIVE', id: 1 },
          { name: 'INACTIVE', id: 2 },
        ];

        var idStatus = this.idStatus;
        this.companyStatus = this.allStatus.filter(function (item) {
          return item.id === idStatus;
        })[0];

        this.selected = false;
        this.phoneMask =
          !this.phone || this.phone.length === 11
            ? '(99) ?99999-9999'
            : '(99) 9999-9999';
      }

      function title() {
        return this.name;
      }

      function details() {
        return (
          $filter('translate')('CONTACT TAG') +
          this.contactPerson +
          (this.phone
            ? ', ' + $filter('translate')('PHONE TAG') + this.phone
            : '') +
          ', ' +
          $filter('translate')('EMAIL TAG') +
          this.email
        );
      }

      function tags() {
        var tags = [
          $filter('translate')('USERS TAG') +
            (this.contract.userCount ? this.contract.userCount : '0') +
            (this.contract.usersLimit ? ' de ' + this.contract.usersLimit : ''),
        ];

        if (this.hasAutoLogin) {
          tags.push('AutoLogin');
        }

        if (this.canExportMedia) {
          tags.push($filter('translate')('CAN EXPORT MEDIA TAG'));
        }

        if (this.canScheduledSend) {
          tags.push($filter('translate')('CAN SCHEDULED SEND TAG'));
        }

        return tags;
      }

      function removeMask() {
        if (this.phone && this.phone.length === 10) {
          this.phoneMask = '(99) 9999-9999';
        } else {
          this.phoneMask = '(99) ?99999-9999';
        }
      }

      function placeMask() {
        this.phoneMask = '(99) ?99999-9999';
      }

      function isCnpjValid() {
        if (this.cnpj !== null)
          return (
            this.cnpj.length === 0 || validationService.validateCNPJ(this.cnpj)
          );
      }

      function isValid() {
        var isValid = true;

        isValid = this.isCnpjValid();

        return isValid;
      }

      function isEnabled() {
        return (
          this.contract.usersLimit === 0 ||
          this.contract.usersLimit - this.contract.userCount > 0 ||
          this.selected
        );
      }

      function getBase64() {
        if (this.logoFile) {
          this.logoFilename = this.logoFile.name;
          var reader = new FileReader();
          var that = this;
          reader.readAsDataURL(this.logoFile);
          reader.onload = function () {
            if (that.logoFile) {
              var r = reader.result;
              var img = new Image(293, 75);
              img.src = r;
              if (img.width !== 293 || img.height !== 75) {
                that.logoFile = null;
                that.logoFilename = null;
                that.logoBase64 = '';
                toastr.options = {
                  closeButton: true,
                  debug: false,
                  progressBar: false,
                  preventDuplicates: false,
                  positionClass: 'toast-top-center',
                  showDuration: '1000',
                  hideDuration: '1000',
                  timeOut: '7000',
                  extendedTimeOut: '1000',
                  showEasing: 'swing',
                  hideEasing: 'linear',
                  showMethod: 'fadeIn',
                  hideMethod: 'fadeOut',
                };

                toastr['warning']($filter('translate')('LOGO COMPANY LIMIT'));
              } else {
                that.logoBase64 = img.src;
              }
              $scope.$apply();
            }
          };
          reader.onerror = function () {};
        } else if (this.logoFileByte) {
          this.logoBase64 = window.btoa(
            String.fromCharCode.apply(null, new Uint8Array(this.logoFileByte))
          );
        } else {
          return '';
        }
      }

      function get64() {
        this.getBase64();
        return this.logoBase64;
      }

      function run() {
        try {
          Company.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            details: logWrapper(
              details,
              runtimeConstant.isDebugModelsInternals
            ),
            tags: logWrapper(tags, runtimeConstant.isDebugModelsInternals),
            removeMask: logWrapper(
              removeMask,
              runtimeConstant.isDebugModelsInternals
            ),
            placeMask: logWrapper(
              placeMask,
              runtimeConstant.isDebugModelsInternals
            ),
            isCnpjValid: logWrapper(
              isCnpjValid,
              runtimeConstant.isDebugModelsInternals
            ),
            isValid: logWrapper(
              isValid,
              runtimeConstant.isDebugModelsInternals
            ),
            isEnabled: logWrapper(
              isEnabled,
              runtimeConstant.isDebugModelsInternals
            ),
            getBase64: logWrapper(
              getBase64,
              runtimeConstant.isDebugModelsInternals
            ),
            get64: logWrapper(get64, runtimeConstant.isDebugModelsInternals),
          };

          return Company;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
